import { featuresData } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            为什么选择鬼父在线
          </h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">
            致力于为动漫爱好者提供最优质的资源导航与观看体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {featuresData.map((feature) => (
            <div
              key={feature.title}
              className="group p-6 rounded-xl bg-background-50 hover:bg-primary-50 transition-colors cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mb-4 group-hover:bg-accent-200 transition-colors">
                <i className={`${feature.icon} text-xl`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}